export const SPECIFIC_ERROR = 'SPECIFIC_ERROR';
export const GENERIC_ERROR = 'GENERIC_ERRORGENERIC_ERROR';
